export default __webpack_public_path__ + "static/process-animated-29281e72868682433e9c89ac7314531b.gif";